import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

// import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({});

class EarringSplash extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
    super(props);
    this.state = {

    };
	}

	componentDidMount() {
    document.title = 'Diamonds Direct';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  splashNav(sku) {
    this.internalNav('jewelry/' + sku);
  }

	render() {
		return <div className='EarringSplash'>
      <div className='esTop'>
        <div className='esTopRow'>
          <div className='esItem'>
            <div className='esItemImg'>
              <img src='https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/earring/saphhoop.png' />
            </div>
            <div className='esItemButtonWrapper'>
              <button className='esItemButton' onClick={() => this.splashNav('ECLST01656')}>Shop this Earring</button>
            </div>
          </div>
          <div className='esItem'>
            <div className='esItemImg'>
              <img src='https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/earring/goldhoop.png' />
            </div>
            <div className='esItemButtonWrapper'>
              <button className='esItemButton' onClick={() => this.splashNav('EHOOP03171')}>Shop this Earring</button>
            </div>
          </div>
          <div className='esItem'>
            <div className='esItemImg'>
              <img src='https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/earring/diamondhoop.png' />
            </div>
            <div className='esItemButtonWrapper'>
              <button className='esItemButton' onClick={() => this.splashNav('EHOOP01639')}>Shop this Earring</button>
            </div>
          </div>
        </div>
      </div>
      <div className='esMid'>
        <div className='esMidLeft'></div>
        <div className='esMidRight'>
          <div className='esMidItemImg'>
            <img src='https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/earring/butterfly.png' />
          </div>
          <div className='esMidItemTitle'>Diamond Accented Butterfly Studs</div>
          <div className='esMidItemCopy'>These nature-inspired butterfly studs sparkle with round brilliant diamonds.</div>
          <div className='esMidItemButtonWrapper'>
            <button className='esItemButton' onClick={() => this.splashNav('EFAND12750')}>Shop this Earring</button>
          </div>
        </div>
      </div>
      <div className='esBottom'>
        <div className='esBottomRow'>
          <div className='esItem'>
            <div className='esItemImg'>
              <img src='https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/earring/emerald.png' />
            </div>
            <div className='esItemButtonWrapper'>
              <button className='esItemButton' onClick={() => this.splashNav('ECLST05118')}>Shop this Earring</button>
            </div>
          </div>
          <div className='esItem'>
            <div className='esItemImg'>
              <img src='https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/earring/ruby.png' />
            </div>
            <div className='esItemButtonWrapper'>
              <button className='esItemButton' onClick={() => this.splashNav('ECLST03032')}>Shop this Earring</button>
            </div>
          </div>
          <div className='esItem'>
            <div className='esItemImg'>
              <img src='https://ddw2.diamondsdirect.com/img/gallery/fashion/splash/earring/aqua.png' />
            </div>
            <div className='esItemButtonWrapper'>
              <button className='esItemButton' onClick={() => this.splashNav('TACSS00080')}>Shop this Earring</button>
            </div>
          </div>
        </div>
      </div>
		</div>;
	}
}
export default EarringSplash;

function mapStateToProps(state) {
  return {

  };
}

export const EarringSplashContainer = connect(
  mapStateToProps,
  allActionCreators
)(EarringSplash);


// WEBPACK FOOTER //
// ./src/components/views/gallery/blocks/splash/EarringSplash.jsx